<template>
  <v-container class="text-center pt-12">
    <v-row>
      <v-col cols="12">
        <hr />
        <h2 class="mt-6">Questions &amp; answers</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4" class="px-6">
        <h3 class="mb-2">How do I cancel my subscription?</h3>
        <p>
          You can send us an email at
          <a :href="`mailto:${whitelabel.cancelSubscriptionEmail}`">{{
            whitelabel.cancelSubscriptionEmail
          }}</a>
          and we will ensure that your subscription is cancelled with immediate
          effect. Kindly note that you will then, also, immediately lose access
          to the benefits associated with the subscription.
        </p>
      </v-col>
      <v-col cols="12" md="4" class="px-6">
        <h3 class="mb-2">
          If I select the subscription option, when will the next billing cycle
          take place?
        </h3>
        <p>
          The next billing date will take place, to your credit card, exactly
          one year from the day on which you made the initial payment.
        </p>
      </v-col>
      <v-col cols="12" md="4" class="px-6">
        <h3 class="mb-2">Can I upgrade to unlimited updates?</h3>
        <p>
          Unfortunately you cannot. You can return to the platform to do the
          update and pay the basic fee once again, to draft your new will.
          Should you then wish to subscribe to unlimted updates, you will be
          able to do so.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'PaymentQuestions',
  };
</script>
